import styled from "styled-components";

export const RowProgress = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
  margin-bottom: 8px;

  > * {
    flex-shrink: 0;
    width: 100%;
    max-width: 100%;
  }
`

export const SpanProgressValue = styled.span`
  width: initial;
  font-size: 0.8rem;
`

export const SpanProgressTitle = styled.span`
  font-size: 0.8rem;
`